import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../nodeIds';

export const contractCorrespondenceLanguage: AnswerPathTreeNode = {
  path: 'correspondenceLanguage',
  nodeId: NodeIds.contractCorrespondenceLanguage,
};
